import React from 'react';
import styled from 'styled-components';
import { PlaceholderNavigationItems } from './placeholder-navigation-options';

export const NAV_OPTIONS = {
  Map: 'Map',
  List: 'List',
  Dashboard: 'Dashboard',
  Back: 'Back',
  Refresh: 'Refresh',
};

/* **********START DEFAULT OPINIONATED STYLES ********** */
const ErrorPlaceHolderWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: ${(props) =>
    props.layout === 'vertical' ? 'column-reverse' : 'row'};
  justify-content: center;
  align-items: center;
  width: fit-content;
  margin: auto;
`;

const ErrorMessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 30px;
  margin-top: ${(props) => (props.layout === 'vertical' ? '15px' : 'unset')};
`;

const ErrorMessageHeaderText = styled.span`
  font-size: 32px;
  color: #101938;
  line-height: 1.56;
  font-weight: 600;
  width: 370px;
`;

const ErrorMessageSubtext = styled.span`
  padding: 42px 0px;
  font-size: 14px;
  line-height: 1px;
  font-weight: bold;
  color: #101938;
`;
/* **********END DEFAULT OPINIONATED STYLES ********** */

const StylerDiv = styled.div`
  /* I am use to override styles from inline style object */
`;

/**
 * Flexible Error Placeholder view. Provides some default opinionated styles based
 * on the current Zeplin designs that are easy to override.
 *
 * The Error placeholder is broken down into a few parts:
 * 1) ErrorMessageHeaderText - Accepts a string of text or component
 * 2) ErrorMessageSubtext - Accepts a string of text or component
 * 3) PlaceholderNavigationItems - Accepts array of options ['Back', 'Map', 'Dashboard', 'List'] and
 * will provide default navigation buttons. Also can accept component.
 * 4) renderErrorMessage - Image to display or component
 *
 * Note: There is an optionalNavCB that can be passed which will be called before
 * navigation happens. Use this CB to cleanup error flags before navigation etc.
 *
 * Also, each section is wrapped in a StylerDiv. This div can be used to provide a styles object
 * that includes styles for sections 1, 2, or 4.
 *
 * @export
 * @param {*} props
 * @returns ErrorPlaceholder as JSX.Element
 */
export function GenericErrorPlaceholder(props) {
  const {
    renderErrorMessageHeaderText,
    renderErrorMessageSubtext,
    renderNavigationOptions,
    renderErrorImage,
    styles,
    layout = 'horizontal',
    optionalNavCB,
  } = props;
  return (
    <ErrorPlaceHolderWrapper layout={layout}>
      <ErrorMessageWrapper layout={layout}>
        <ErrorMessageHeaderText>
          <StylerDiv style={{ ...styles?.errorHeaderText }}>
            {renderErrorMessageHeaderText}
          </StylerDiv>
        </ErrorMessageHeaderText>
        <ErrorMessageSubtext>
          <StylerDiv style={{ ...styles?.errorSubtext }}>
            {renderErrorMessageSubtext}
          </StylerDiv>
        </ErrorMessageSubtext>
        {renderNavigationOptions && (
          <PlaceholderNavigationItems
            renderNavigationOptions={renderNavigationOptions}
            optionalCB={optionalNavCB}
          />
        )}
      </ErrorMessageWrapper>
      <StylerDiv style={{ ...styles?.errorImage }}>
        {renderErrorImage}
      </StylerDiv>
    </ErrorPlaceHolderWrapper>
  );
}
